import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService } from './shared/services/user-session.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    title = 'Wear&Care';
    constructor(translate: TranslateService, private userSessionService: UserSessionService) {
		const lang = userSessionService.getLanguage();
		if (lang) {
			translate.use(lang);
		} else {
			translate.use('en');
		}
    }
}
